import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {RegistryOfficeDto} from "../registry-office.dto";

export class SearchRegistryOfficeRes extends SearchResultDto {

  public override readonly items: SearchRegistryOfficeItem[] = [];

  constructor(init?: Partial<SearchRegistryOfficeRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchRegistryOfficeItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchRegistryOfficeItem extends RegistryOfficeDto implements SearchItem {

  public addressName: string | undefined;
  public addressStreetFull: string | undefined;
  public addressZipCode: string | undefined;
  public addressCity: string | undefined;

  constructor(init?: Partial<SearchRegistryOfficeItem>) {
    super(init);
    Object.assign(this, init);
  }
}
